import { render, staticRenderFns } from "./courseAppointmentDetail.vue?vue&type=template&id=e5e01cec&scoped=true"
import script from "./courseAppointmentDetail.vue?vue&type=script&lang=js"
export * from "./courseAppointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./courseAppointmentDetail.vue?vue&type=style&index=0&id=e5e01cec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e01cec",
  null
  
)

export default component.exports